import { RolesTable } from '@/components/features/roles'

export const RolesPage = () => {
  return (
    <div >
      <RolesTable />
    </div>
  )
}
